//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The register request model
* 
* @param emailAddress The user email
* @param familyName The family name of the user
* @param givenName The given name
* @param locale The locale from user settings or system default
* @param password password
* @param dateOfBirth The birth date of the user
*/
@Serializable

data class RegisterRequest (


      /* The user email */
    @SerialName(value = "emailAddress") @Required val emailAddress: kotlin.String,


      /* The family name of the user */
    @SerialName(value = "familyName") @Required val familyName: kotlin.String,


      /* The given name */
    @SerialName(value = "givenName") @Required val givenName: kotlin.String,


      /* The locale from user settings or system default */
    @SerialName(value = "locale") @Required val locale: kotlin.String,


      /* password */
    @SerialName(value = "password") @Required val password: kotlin.String,


      /* The birth date of the user */
    @SerialName(value = "dateOfBirth") val dateOfBirth: kotlin.time.Instant? = null


) {




  }

